var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.tags,"label":_vm.$t('labels.tags'),"hide-details":"","multiple":"","outlined":"","chips":""},on:{"change":_vm.handleChange},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})
}
var staticRenderFns = []

export { render, staticRenderFns }